import { render, staticRenderFns } from "./PurchasingRetur.vue?vue&type=template&id=079868aa"
import script from "./PurchasingRetur.vue?vue&type=script&lang=js"
export * from "./PurchasingRetur.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports